"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _focusTrapUtils = require("./focus-trap-utils");

var _modal = require("../../components/modal/modal.component");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FocusTrap = ({
  children,
  autoFocus = true,
  focusFirstElement,
  bespokeTrap,
  wrapperRef
}) => {
  const trapRef = (0, _react.useRef)(null);
  const firstOpen = (0, _react.useRef)(true);
  const [focusableElements, setFocusableElements] = (0, _react.useState)();
  const [firstElement, setFirstElement] = (0, _react.useState)();
  const [lastElement, setLastElement] = (0, _react.useState)();
  const {
    isAnimationComplete
  } = (0, _react.useContext)(_modal.ModalContext);
  const hasNewInputs = (0, _react.useCallback)(candidate => {
    if (!focusableElements || candidate.length !== focusableElements.length) {
      return true;
    }

    return Array.from(candidate).some((el, i) => el !== focusableElements[i]);
  }, [focusableElements]);
  const updateFocusableElements = (0, _react.useCallback)(() => {
    if (wrapperRef) {
      const ref = wrapperRef.current;
      const elements = Array.from(ref.querySelectorAll(_focusTrapUtils.defaultFocusableSelectors)).filter(el => Number(el.tabIndex) !== -1);

      if (hasNewInputs(elements)) {
        setFocusableElements(Array.from(elements));
        setFirstElement(elements[0]);
        setLastElement(elements[elements.length - 1]);
      }
    }
  }, [hasNewInputs, wrapperRef]);
  (0, _react.useEffect)(() => {
    const observer = new MutationObserver(updateFocusableElements);
    observer.observe(trapRef.current, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });
    return () => observer.disconnect();
  }, [updateFocusableElements]);
  (0, _react.useLayoutEffect)(() => {
    updateFocusableElements();
  }, [children, updateFocusableElements]);
  (0, _react.useEffect)(() => {
    if (autoFocus && firstOpen.current && isAnimationComplete && (focusFirstElement || firstElement)) {
      (0, _focusTrapUtils.setElementFocus)(focusFirstElement || firstElement);
      firstOpen.current = false;
    }
  }, [autoFocus, firstElement, focusFirstElement, isAnimationComplete]);
  (0, _react.useEffect)(() => {
    const trapFn = ev => {
      if (bespokeTrap) {
        bespokeTrap(ev, firstElement, lastElement);
        return;
      }

      const {
        activeElement
      } = document;

      if (ev.key === "Tab") {
        if (!focusableElements.length) {
          /* Block the trap */
          ev.preventDefault();
        } else if (ev.shiftKey) {
          /* shift + tab */
          if (activeElement === firstElement) {
            lastElement.focus();
            ev.preventDefault();
          } // If current element is radio button -
          // find next non radio button element


          if ((0, _focusTrapUtils.isRadio)(activeElement)) {
            const nextIndex = (0, _focusTrapUtils.nextNonRadioElementIndex)(activeElement, focusableElements);
            (0, _focusTrapUtils.setElementFocus)(focusableElements[nextIndex]);
            ev.preventDefault();
          }
        } else if (activeElement === lastElement) {
          firstElement.focus();
          ev.preventDefault();
        }
      }
    };

    document.addEventListener("keydown", trapFn);
    return function cleanup() {
      document.removeEventListener("keydown", trapFn);
    };
  }, [firstElement, lastElement, focusableElements, bespokeTrap]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: trapRef
  }, children);
};

FocusTrap.propTypes = {
  children: _propTypes.default.node.isRequired,

  /** flag to set focus automatically on first render */
  autoFocus: _propTypes.default.bool,

  /** provide a custom first element to focus */
  focusFirstElement: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),

  /** a custom callback that will override the default focus trap behaviour */
  bespokeTrap: _propTypes.default.func,

  /** a ref to the container wrapping the focusable elements */
  wrapperRef: _propTypes.default.shape({
    current: _propTypes.default.any
  })
};
var _default = FocusTrap;
exports.default = _default;